import { render, staticRenderFns } from "./cards-list.vue?vue&type=template&id=eac4e196&scoped=true&"
import script from "./cards-list.vue?vue&type=script&lang=js&"
export * from "./cards-list.vue?vue&type=script&lang=js&"
import style0 from "./cards-list.vue?vue&type=style&index=0&id=eac4e196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac4e196",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
